import { combineReducers } from 'redux';
import { Actions, ActionTypes } from './actions';

export const ownerImpersonationId = (state = '', action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.ADMIN_IMPERSONATE_USER_START:
			return action.payload.ownerId;
		case ActionTypes.ADMIN_IMPERSONATE_USER_END:
			return '';
		default:
			return state;
	}
};

export const isImpersonating = (state = false, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.ADMIN_IMPERSONATE_USER_START:
			return true;
		case ActionTypes.ADMIN_IMPERSONATE_USER_END:
			return false;
		default:
			return state;
	}
};

interface IAdminState {
	ownerImpersonationId: ReturnType<typeof ownerImpersonationId>;
	isImpersonating: ReturnType<typeof isImpersonating>;
}

export default combineReducers<IAdminState>({
	ownerImpersonationId,
	isImpersonating
});
